var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jumbotron text-center col-lg-12",staticStyle:{"background":"white"}},[_c('div',[_c('img',{staticStyle:{"width":"90%"},attrs:{"src":require("../../assets/aboutus.png")}})]),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../assets/ceo.png")}})])
}]

export { render, staticRenderFns }